export const generatedBusinessPlatformRoadmap = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-22T00:00:00.000Z",
  "mode": "deterministic-business-platform-roadmap",
  "operatingRule": "This roadmap converts the product strategy into hash-backed capability, source, model, customer-value, blocker, and proof-gate records. It is planning and release-control evidence, not a science result or legal clearance.",
  "businessWedge": "Paid feasibility intelligence for space startups, deep-tech investors, labs, universities, strategic foresight teams, and aerospace concept teams: given current public evidence, which off-world industrial scenario is plausible, what assumptions drive the answer, what data is weak, and what proof would change the ranking?",
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "sourceReferenceCount": 14,
  "capabilityCount": 6,
  "phaseCount": 6,
  "blockedCapabilityCount": 6,
  "externalApprovalRequiredCount": 4,
  "linkedEvidenceHashes": {
    "sourceUseClearanceDossier": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
    "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
    "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
    "runtimeClosurePacket": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
    "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
    "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
    "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
    "modelValidationProtocolLedger": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
    "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
    "workspaceLedger": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
    "scenarioNotebookPack": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
    "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
    "customerReportPacketLedger": "sha256-dce55147724b8c11e4fd3520a1aa62b076490ea81e6670251dc5111016a8952c",
    "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7"
  },
  "sourceReferences": [
    {
      "id": "jpl-horizons-api",
      "title": "JPL Horizons API",
      "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html",
      "sourceType": "primary-ephemeris-api",
      "plannedUse": "Generate reviewed snapshots for observer/vector ephemerides, distances, light-time, elongation, and time-scale metadata.",
      "useBoundary": "Snapshot-first; live API refresh cannot be the only source of truth for customer reports."
    },
    {
      "id": "jpl-sbdb-cad",
      "title": "JPL SBDB and Close-Approach Data APIs",
      "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
      "sourceType": "primary-small-body-api",
      "plannedUse": "Screen small-body geometry and close-approach opportunities before any resource-candidate promotion.",
      "useBoundary": "Geometry and close approach data do not prove composition or resource value."
    },
    {
      "id": "naif-spice-gf",
      "title": "NASA NAIF SPICE Geometry Finder",
      "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
      "sourceType": "primary-geometry-toolkit",
      "plannedUse": "Compute event windows, occultations, conjunctions, and contact constraints from reviewed kernels.",
      "useBoundary": "Requires kernel manifest custody and runtime artifact validation before claim promotion."
    },
    {
      "id": "orekit",
      "title": "Orekit",
      "url": "https://www.orekit.org/",
      "sourceType": "open-source-astrodynamics-library",
      "plannedUse": "Independent propagation, event detection, and trajectory sanity checks.",
      "useBoundary": "Blocked until Java runtime, Orekit data path, sidecar jar, and artifact intake pass."
    },
    {
      "id": "nasa-gmat",
      "title": "NASA GMAT",
      "url": "https://gmat.atlassian.net/wiki/spaces/GW/overview",
      "sourceType": "open-source-mission-analysis-tool",
      "plannedUse": "Independent mission-design transfer validation and force-model comparison.",
      "useBoundary": "Blocked until installed executable, script custody, run logs, and output manifest pass."
    },
    {
      "id": "tudat",
      "title": "Tudat Space",
      "url": "https://docs.tudat.space/en/latest/",
      "sourceType": "open-source-astrodynamics-library",
      "plannedUse": "Cross-tool trajectory validation and residual checks against Orekit/GMAT/SPICE products.",
      "useBoundary": "Blocked until TudatPy runtime and sidecar artifact intake pass."
    },
    {
      "id": "openmdao-dymos",
      "title": "OpenMDAO and Dymos",
      "url": "https://openmdao.org/",
      "sourceType": "open-source-optimization-framework",
      "plannedUse": "Scenario optimization, sensitivity analysis, and Pareto-frontier experiments.",
      "useBoundary": "Use as planning optimization only until inputs and economics are source-cleared."
    },
    {
      "id": "nasa-cdaweb",
      "title": "NASA SPDF CDAWeb",
      "url": "https://cdaweb.gsfc.nasa.gov/",
      "sourceType": "primary-space-environment-archive",
      "plannedUse": "Attach heliophysics and space-environment records to comms, radiation, and autonomy assumptions.",
      "useBoundary": "Mission-environment use requires dataset-specific variable, unit, version, and citation custody."
    },
    {
      "id": "noaa-swpc",
      "title": "NOAA SWPC Products and Data",
      "url": "https://www.spaceweather.gov/products-and-data",
      "sourceType": "primary-space-weather-service",
      "plannedUse": "Use operational space-weather products as inputs to comms/autonomy risk context.",
      "useBoundary": "Forecast products are not deterministic long-horizon industrial proof."
    },
    {
      "id": "nist-constants",
      "title": "NIST Fundamental Physical Constants",
      "url": "https://physics.nist.gov/cuu/Constants/",
      "sourceType": "standards-body-source",
      "plannedUse": "Canonical constants, units, and uncertainty metadata for formulas.",
      "useBoundary": "Standards text and tables require source-use review before customer redistribution."
    },
    {
      "id": "nist-chemistry-webbook",
      "title": "NIST Chemistry WebBook",
      "url": "https://webbook.nist.gov/chemistry/",
      "sourceType": "standards-body-source",
      "plannedUse": "Thermochemical and thermophysical source records for process-model assumptions.",
      "useBoundary": "Copyright and SRD terms require source-use review before customer-use payloads."
    },
    {
      "id": "cantera",
      "title": "Cantera",
      "url": "https://cantera.org/",
      "sourceType": "open-source-chemistry-tool",
      "plannedUse": "Chemical kinetics, thermodynamics, and transport calculations for process sidecars.",
      "useBoundary": "Model mechanism files and material parameters require independent source custody."
    },
    {
      "id": "materials-project-api",
      "title": "Materials Project API",
      "url": "https://api.materialsproject.org/docs",
      "sourceType": "materials-database-api",
      "plannedUse": "Screen candidate materials and properties for process-body fit hypotheses.",
      "useBoundary": "API key, citation, license, and redistribution constraints must be reviewed before customer use."
    },
    {
      "id": "nasa-pds",
      "title": "NASA Planetary Data System Data Search",
      "url": "https://pds.nasa.gov/datasearch/data-search/",
      "sourceType": "primary-planetary-archive",
      "plannedUse": "Attach mission/archive records for surface, composition, and small-body evidence.",
      "useBoundary": "Dataset-specific citations and archive labels must be preserved."
    }
  ],
  "capabilities": [
    {
      "id": "evidence-provenance-layer",
      "label": "Evidence and provenance layer",
      "phase": "Phase 1",
      "readinessState": "partially-implemented-fail-closed",
      "customerValue": "Makes every conclusion inspectable by source, units, uncertainty, hash, and allowed-use status.",
      "sourceRefs": [
        "jpl-horizons-api",
        "jpl-sbdb-cad",
        "nist-constants",
        "nasa-pds"
      ],
      "currentEvidence": {
        "sourceUseClearanceDossierHash": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
        "sourceUseRightsLedgerHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "blockedSourceUseCount": 33
      },
      "proofGates": [
        "Every customer-used source has terms, citation, license, query, timestamp, units, uncertainty, and hash metadata.",
        "Raw payload redistribution is explicitly allowed or excluded.",
        "Derived values have reviewer-approved customer-use status."
      ],
      "blockers": [
        "Customer/commercial source-use clearance is still blocked.",
        "Raw payload redistribution remains disallowed until source-specific review passes."
      ],
      "nextBuildActions": [
        "Add source-specific rights attachments for P0/P1 sources.",
        "Bind customer report exports to cleared citation-only or derived-value payloads."
      ],
      "capabilityHash": "sha256-a4c5eb01e52a16061cf53a6aebdc2c569a7365f9f7fad09485a187632255d01a"
    },
    {
      "id": "science-compute-sidecar",
      "label": "Science compute sidecar",
      "phase": "Phase 2",
      "readinessState": "partial-runtime-evidence",
      "customerValue": "Moves heavy modeling out of the browser and creates reproducible artifacts customers can audit.",
      "sourceRefs": [
        "naif-spice-gf",
        "orekit",
        "nasa-gmat",
        "tudat",
        "openmdao-dymos"
      ],
      "currentEvidence": {
        "sidecarReadinessLedgerHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "runtimeClosurePacketHash": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
        "readyToRunContractCount": 0,
        "blockedRuntimeContractCount": 3
      },
      "proofGates": [
        "Each runtime artifact is generated by the sidecar worker, not hand-authored.",
        "Each artifact includes command, input hashes, output hashes, checksums, units, limitations, and validation status.",
        "Orekit/GMAT/Tudat independent comparison artifacts pass intake before high-confidence trajectory claims."
      ],
      "blockers": [
        "Orekit remains blocked by Java runtime, data path, and sidecar jar custody.",
        "GMAT remains blocked by missing executable/run evidence.",
        "Tudat remains blocked by missing TudatPy runtime."
      ],
      "nextBuildActions": [
        "Install reviewed Java/Orekit data and build the Orekit sidecar jar.",
        "Install GMAT R2026a or reviewed equivalent and capture script/run-output custody.",
        "Install TudatPy in the sidecar environment and run cross-tool residual checks."
      ],
      "capabilityHash": "sha256-2badfbb5b3c5b97f907f818b62ad54abd2aa1c3a618ac9781bd9b337ba13e5bf"
    },
    {
      "id": "scenario-intelligence-engine",
      "label": "Scenario intelligence engine",
      "phase": "Phase 3",
      "readinessState": "beta-modeling-ready-not-commercial",
      "customerValue": "Compares Moon, Mars, Mercury, asteroid, orbital, and Earth-based scenarios with transparent uncertainty and sensitivity.",
      "sourceRefs": [
        "jpl-horizons-api",
        "openmdao-dymos",
        "noaa-swpc",
        "nasa-cdaweb"
      ],
      "currentEvidence": {
        "scenarioComparisonBoardHash": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
        "modelRunComparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "scenarioTraceabilityMatrixHash": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6"
      },
      "proofGates": [
        "Scenario ranking includes uncertainty bands and sensitivity drivers.",
        "Mercury-first is never hardcoded and can lose under conservative assumptions.",
        "Every scenario decision links sources, assumptions, model runs, sidecars, and blockers."
      ],
      "blockers": [
        "Commercial economics claims remain blocked.",
        "Runtime sidecar gaps prevent high-confidence transfer/logistics claims."
      ],
      "nextBuildActions": [
        "Attach dated economics source records and uncertainty distributions.",
        "Run scenario deltas after each P0 evidence gap closes."
      ],
      "capabilityHash": "sha256-6e7f980226eb0a306f6a7a163d05874c107e23ae0ea6fd70efdec3325b184726"
    },
    {
      "id": "materials-process-modeling",
      "label": "Materials and process modeling",
      "phase": "Phase 4",
      "readinessState": "blocked-for-process-physics-proof",
      "customerValue": "Turns generic industrial promise into process-specific thermal, vacuum, material, quality, and throughput evidence.",
      "sourceRefs": [
        "nist-chemistry-webbook",
        "cantera",
        "materials-project-api",
        "nasa-pds"
      ],
      "currentEvidence": {
        "materialsProcessEvidenceLedgerHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
        "processCount": 3,
        "blockedProcessCount": 3
      },
      "proofGates": [
        "Each process has source-backed material properties, units, uncertainty, and valid temperature/pressure regime.",
        "Cantera/materials calculations include input files, mechanism/data provenance, and validation residuals.",
        "Process-body fit scores remain heuristics until process physics and feedstock evidence pass."
      ],
      "blockers": [
        "Process records remain blocked from throughput, quality, and cost claims.",
        "Candidate material and feedstock records need source-specific promotion."
      ],
      "nextBuildActions": [
        "Create NIST/Materials Project intake packets for selected process materials.",
        "Add Cantera sidecar artifact template for one narrow thermal/process case."
      ],
      "capabilityHash": "sha256-5cb9cd37e10acac82a3fb8cad5e4af76d4f13a4f0d9438819671c5cc2f634946"
    },
    {
      "id": "business-research-platform",
      "label": "Business research platform",
      "phase": "Phase 5",
      "readinessState": "beta-review-only",
      "customerValue": "Packages feasibility intelligence into repeatable paid research workspaces, notebooks, reports, approvals, and audit logs.",
      "sourceRefs": [
        "jpl-horizons-api",
        "nasa-pds",
        "nist-constants"
      ],
      "currentEvidence": {
        "workspaceLedgerHash": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
        "scenarioNotebookPackHash": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
        "researchPackageManifestHash": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
        "customerReportPacketLedgerHash": "sha256-dce55147724b8c11e4fd3520a1aa62b076490ea81e6670251dc5111016a8952c",
        "blockedWorkspaceCount": 3,
        "blockedPackageCount": 3
      },
      "proofGates": [
        "At least one workspace has no blocked source, sidecar, package, or review gates.",
        "Customer report exports include proof gates, allowed-use boundaries, source appendix, and replay commands.",
        "Approval workflow records named reviewer decisions for source, science, UI, and release claims."
      ],
      "blockers": [
        "All workspaces currently have at least one blocked review gate.",
        "All customer-facing packages remain beta-blocked."
      ],
      "nextBuildActions": [
        "Create one scoped paid-beta workspace with explicitly limited customer-use boundaries.",
        "Add reviewer-specific signoff receipts for UI, source-use, and report package acceptance."
      ],
      "capabilityHash": "sha256-417a3d6cb7cf0a78faa43ccd800a92d4ff0d5fc65066ff91908eddde77eadd0c"
    },
    {
      "id": "operational-release-system",
      "label": "Operational release system",
      "phase": "Phase 0",
      "readinessState": "live-gated-but-not-release-complete",
      "customerValue": "Keeps the beta testable, gated, monitored, reproducible, and honest about incomplete gates.",
      "sourceRefs": [],
      "currentEvidence": {
        "readinessBlockingCategoryCount": 4,
        "lowestReadinessScore": 90,
        "publicBetaAllowed": false,
        "customerDeliveryAllowed": false
      },
      "proofGates": [
        "Cloudflare Access owner/reviewer browser approval is recorded.",
        "Alert webhook failure and recovery delivery are proven.",
        "CI/secrets-backed deploy receipt is attached.",
        "Exact mockup fidelity owner approval is recorded."
      ],
      "blockers": [
        "Alert webhook/recovery proof is not attached.",
        "Owner browser approval and exact UI fidelity approval are not attached.",
        "Remote/secrets-backed CI promotion proof is not attached."
      ],
      "nextBuildActions": [
        "Attach alert webhook and run two-failure plus recovery proof.",
        "Record owner browser approval after Access login.",
        "Attach CI deploy receipt from a clean branch."
      ],
      "capabilityHash": "sha256-8f29b10af10f5c92f7196f541afbdb3b4eade79cbaa0f5c9e1c68ca0fe324396"
    }
  ],
  "phasePlan": [
    {
      "id": "phase-0",
      "label": "Close current beta gaps",
      "entryState": "Live gated beta exists, but release is not complete.",
      "exitCriteria": [
        "Alert webhook/recovery proof attached.",
        "Owner/reviewer Access approval attached.",
        "Exact six-page UI fidelity approval attached.",
        "CI/secrets-backed deployment receipt attached."
      ],
      "phaseHash": "sha256-dbba0d2c7cc6fcbb6db8345e49f71a1624d8eb0489f7850781966cc36183e320"
    },
    {
      "id": "phase-1",
      "label": "Source Registry 2.0",
      "entryState": "Source-use workflow exists but customer/commercial use is blocked.",
      "exitCriteria": [
        "P0/P1 source-use packets have reviewer decisions.",
        "Customer exports use cleared citations and derived values only."
      ],
      "phaseHash": "sha256-6dfdcb4a7cec5fb5e5b08bc0e298d33f55dc6a52cd3ae85ee556d2aca9659867"
    },
    {
      "id": "phase-2",
      "label": "Science Sidecar V1",
      "entryState": "SPICE and OpenMDAO/Dymos have runtime evidence; Orekit/GMAT/Tudat are blocked.",
      "exitCriteria": [
        "Orekit, GMAT, and Tudat runtime artifacts pass intake.",
        "Cross-tool residual matrix records acceptable bounds."
      ],
      "phaseHash": "sha256-0035e674077f59b56ae595e67347e33d2e4dc94ecf8c7f5168f8689613dccd63"
    },
    {
      "id": "phase-3",
      "label": "Mission and logistics modeling",
      "entryState": "Scenario comparison exists with explicit blockers.",
      "exitCriteria": [
        "Transfer windows, blackout windows, mass/cost sensitivity, and autonomy indices are reproducible.",
        "Scenario deltas are regenerated after each promoted evidence packet."
      ],
      "phaseHash": "sha256-d8dd878054277a0bf95613d35484404740421bba742f65833a063ed7c239bdd6"
    },
    {
      "id": "phase-4",
      "label": "Industrial process modeling",
      "entryState": "Process records are visible but blocked from physics/cost claims.",
      "exitCriteria": [
        "At least one process model has NIST/materials/Cantera-backed reproducible artifacts.",
        "Process-body fit scores are split into verified physics and heuristic planning layers."
      ],
      "phaseHash": "sha256-57ea92300d6566d2b2f476372e71f26c5ae39991e72f19f1b2fd970f8917dfea"
    },
    {
      "id": "phase-5",
      "label": "Paid feasibility intelligence platform",
      "entryState": "Research packages exist but all are beta-blocked.",
      "exitCriteria": [
        "One limited paid-beta package has source, science, report, and approval gates cleared.",
        "Customer report exports include replay commands, evidence appendix, assumptions, and allowed-use boundaries."
      ],
      "phaseHash": "sha256-3dfd0515db65fbb7d28394f5fe33a698a68da0ebc4ba2fa70f4b2b2c23b78229"
    }
  ],
  "releaseImpact": "Adds an auditable product roadmap to the beta, but does not reduce release blockers. Customer delivery remains blocked until source-use, runtime, package, UI, alerting, and approval gates close.",
  "markdownPath": "public/business-platform-roadmap.md",
  "markdownHash": "sha256-878f85ba99cd7c415663d87a34511991212e56ba48d39def1fef4db5514702ce",
  "roadmapHash": "sha256-91f63c4f84fdf7f86072fbd70e4d1eae414adae082c6d23f82bdf5563ca749ed"
}
;
